import { virtual } from 'haunted';
import { formatPlainText } from '@local/format-plain-text';
import { formatFileSize } from '@outbook/format-file-size';
import { formatBitrateDecimal as formatBitrate } from '@outbook/format-bitrate';
import { getI18n } from './_i18n/i18n.js';

export const TrackInfo = virtual(
  ({ metadata, template, downloadRoute, literals = getI18n() }) => {
    const model = [
      {
        key: literals.title,
        name: 'title',
        value: metadata.title
      },
      {
        key: literals.artist,
        name: 'artist',
        value: metadata.artist
      },
      {
        key: literals.album,
        name: 'album',
        value: metadata.album
      },
      {
        key: literals.year,
        name: 'year',
        value: metadata.date
      },
      {
        key: literals.composer,
        name: 'composer',
        value: metadata.composer
      },
      {
        key: literals.bit_rate,
        name: 'bit_rate',
        value: formatBitrate({ bitrate: metadata.bit_rate })
      },
      {
        key: literals.size,
        name: 'size',
        value: formatFileSize({ size: metadata.size })
      },
      {
        key: literals.copyright,
        name: 'copyright',
        value: metadata.copyright
      },
      {
        key: literals.comment,
        name: 'comment',
        value: metadata.comment
          ? formatPlainText(metadata.comment, literals)
          : null
      },
      {
        key: literals.synopsis,
        name: 'synopsis',
        value: metadata.synopsis
          ? formatPlainText(metadata.synopsis, literals)
          : null
      }
    ];

    return template({
      model,
      downloadRoute
    });
  }
);
